import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import * as Constants from './Constants';
import { apiUrls } from '../../constants/apiUrl';
import { getIntendType, buildUpdateProcessStepPayload, isWHW } from '../../components/common/Helpers/index';

export const getDataFromApi = (data) => ({
  type: Constants.GET_DATA_FROM_API,
  data,
});

export const hideNotificationBar = (data) => ({
  type: Constants.HIDE_NOTIFICATION_BAR,
  data,
});

export const saveSelectedOption = (data) => ({
  type: 'SAVE_SELECTED_SETUP_OPTION',
  data,
});

export const postProInstallationDeviceSetup = (data) => ({
  type: Constants.POST_DATA_PRO_INSTALLATION_DEVICE_SETUP,
  data,
});

export const postPro = (data) => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateProInstallation}`;
  return HttpService.post(apiURL, data);
};

export const getPlansFromApiDev = (data) => ({
  type: Constants.GET_PLANS_FROM_API,
  data,
});

export const updateProcessStepSetup = (data) => ({
  type: Constants.UPDATE_PROCESS_STEP_SETUP,
  data,
});

export const updateProcessStepApi = () => {
  try {
    let postData = {};
    // let apiResponse = '';
    postData = buildUpdateProcessStepPayload(getIntendType(), { processStep: 'InstallType' });
    const apiURL = `${getSecureBaseUrl()}${apiUrls().updateProcessStepAddons}`;
    return HttpService.post(apiURL, postData);
    // apiResponse = HttpService.post(`${getSecureBaseUrl()}${apiUrls().updateProcessStepAddons}`, postData);
    // Promise.all([apiResponse]).then((res) => res);
  } catch (error) {
    console.log('error in /DeviceSetup/actions.js', error);
  }
};

export const getPlansDev = () => {
  // const headers = {
  // "Content-Type":"application/json",
  // "channelId":'VZW-DOTCOM',
  // "x-soe-apikey":"uFWjzl4du5e46whYg73iCGqriX2l62C9"
  // };
  const postData = {};
  const apiURL = `${getSecureBaseUrl()}${apiUrls().homePlansurl}`;
  // return HttpService.post(apiURL, postData, { headers });
  return HttpService.post(apiURL, postData);
};

export const optSelect = (data) => ({
  type: 'OPTION_SELECTED',
  data,
});

export const getButtonDisabledStatus = (data) => ({
  type: 'CONTINUE_BUTTON_ENABLE_STATE',
  data,
});

export const updateSetFlag = (data) => ({
  type: 'SET_FLAG',
  data,
});
